import { render, staticRenderFns } from "./FeatureContent.vue?vue&type=template&id=2c0370e2&scoped=true&"
import script from "./FeatureContent.vue?vue&type=script&lang=js&"
export * from "./FeatureContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0370e2",
  null
  
)

export default component.exports